<template>
  <el-dialog
    :visible.sync="visibility"
    :before-close="fechar"
    width="50%"
    v-loading="loading"
    append-to-body
  >
    <div slot="title" style="font-size: 20px;">
      <i class="el-icon-refresh"></i>
      <span>Troca de Titularidade</span>
    </div>

    <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">    
      <el-steps :active="estagioAtual" style="width: 70%;" finish-status="success" process-status="finish" align-center>
        <el-step title ="Efetuar troca"/>
        <el-step title ="Upload Aditivo"/>
      </el-steps>
    </div>
    
    <el-form :model="form" size="small" label-position="top" hide-required-asterisk v-if="estagioAtual === 0">

      <el-form-item label="Tipo entidade">
        <el-select @change="limparChangeEntidade" v-model="form.tipoEntidade" style="width: 100%;">
          <el-option
            v-for="tipo in tiposEntidade" :key="tipo.id"
            :label="tipo.label"
            :value="tipo.data"
          />
        </el-select>
      </el-form-item>
      
      <div style="margin-top: 30px;" v-if="form.tipoEntidade === 'PROPRIETARIO' && isAdicionarNovoProprietario === false">
        <table class="tabela-detalhes-clientes">
          <thead>
            <th scope="col">Nome</th>
            <th scope="col">Perfil</th>
            <th></th>
          </thead>

          <tbody>
            <tr v-for="(proprietario, index) in listaProprietarios" :key="index">
              <td>{{ proprietario.nome }}</td>
              <td>
               {{ proprietario.perfil }}
              </td>
              <td style="display: flex; flex-direction: row-reverse;">
                <div style="display: flex; flex-direction: row;  gap: 15px;">
                  <el-tooltip :content="verificarProprietarioComTrocaAtiva(proprietario) ? 'Cancelar Troca' : 'Trocar Proprietário'">
                    <el-button @click="selecionarProprietarioParaTroca(index)" :disabled="(proprietarioSelecionadoParaTroca !== undefined || (Object.keys(proprietarioASerRemovido).length !== 0))" v-if="!verificarProprietarioComTrocaAtiva(proprietario)" circle icon="el-icon-refresh" type="warning" size="small" class="btn-box-shadow"/>
                    <el-button @click="desselecionarProprietarioParaTroca(index)" v-else circle icon="el-icon-close" type="danger" size="small" class="btn-box-shadow"/>
                  </el-tooltip>

                  <el-tooltip :content="proprietarioASerRemovido.id ? 'Cancelar Remoção' : 'Remover Proprietário'" v-if="form.tipoEntidade === 'PROPRIETARIO'">
                    <el-button @click="selecionarProprietarioASerRemovidoHandler(proprietario)" v-if="proprietarioASerRemovido.id !== proprietario.id" :disabled="((Object.keys(proprietarioASerRemovido).length !== 0) || proprietarioSelecionadoParaTroca !== undefined || isListaProprietariosSomenteUm)" circle size="small" icon="el-icon-delete" type="danger" class="btn-box-shadow"/>
                    <el-button @click="cancelarRemocaoDeProprietario()" v-if="proprietarioASerRemovido.id && proprietarioASerRemovido.id === proprietario.id" circle size="small" icon="el-icon-close" type="danger" class="btn-box-shadow"/>
                  </el-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style="margin-top: 30px;" v-if="form.tipoEntidade === 'LOCATARIO'">
        <table class="tabela-detalhes-clientes">
          <thead>
            <th scope="col">Nome</th>
            <th scope="col">Perfil</th>
            <th></th>
          </thead>

          <tbody>
            <tr>
              <td>{{ locatario.nome }}</td>
              <td>
               {{ 'Locatário' }}
              </td>
              <td>
                <el-tooltip :content="isSelecionarNovoLocatario ? 'Cancelar Troca' : 'Trocar Locatário'">
                  <el-button @click="trocarLocatario" v-if="!isSelecionarNovoLocatario" circle icon="el-icon-refresh" type="warning" size="small"/>
                  <el-button @click="isSelecionarNovoLocatario = false" v-else circle icon="el-icon-close" type="danger" size="small"/>
                </el-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-form-item :label="isEntidadeProprietario ? 'Novo Proprietário' : 'Novo Locatário'" v-if="isExibirNovoCliente || isAdicionarNovoProprietario === true && adicionandoNovoProprietario === false">
        <div style="display: flex; flex-direction: row; gap: 8px;">
          <el-select
            v-model="clientePesquisado"
            :remote-method="filtrarClientesSelect"
            :loading="loadingCliente"
            value-key="id"
            placeholder="Digite o Nome ou Id do Cliente"
            loading-text="Carregando Clientes"
            no-data-text=""
            filterable
            clearable
            @clear="clientePesquisado = undefined"
            remote
            reserve-keyword
            style="width: 100%"
          >
            <el-option
              v-for="item in clientesDisponiveisFiltrado"
              :key="item.id"
              :label="`(${item.idNaImobiliaria})${item.nome}`"
              :value="item"
            />
          </el-select>
          <el-button v-if="clientePesquisado" :icon="isAdicionarNovoProprietario === true ? 'el-icon-check' : 'el-icon-refresh'" round class="btn-box-shadow" type="success" @click="confirmarNovoClienteHandler()">Confirmar</el-button>
        </div>
      </el-form-item>

      <el-form-item v-if="isExibirNovoCliente">
        <el-checkbox v-model="form.naoTransferirRecibosAtrasados">{{ `Não transferir recibos atrasados para novo ${form.tipoEntidade === 'PROPRIETARIO' ? 'proprietario' : 'locatario'}.` }}</el-checkbox>
      </el-form-item>

      <el-form-item v-if="proprietarioASerRemovido.id || isAdicionarNovoProprietario === true">
        <table class="tabela-detalhes-clientes" style="font-size: 10px; padding: 0px 15px;">
          <thead>
            <th scope="col">Proprietário</th>
            <th scope="col">Participação no Imóvel</th>
          </thead>

          <tbody>
            <tr v-for="(proprietario, index) in listaProprietarios.filter(item => item.id !== proprietarioASerRemovido.id)" :key="index">
              <td>{{ proprietario.nome }}</td>
              <td>
                <el-input-number v-model="proprietario.perfis[0].participacaoImovel"
                :precision="2"
                :step="5.0"
                :min="0"
                :max="maxPara(index)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </el-form-item>

      <el-form-item v-if="proprietarioASerRemovido.id">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-button @click="confirmarRemocaoProprietarioHandler(proprietarioASerRemovido)" icon="el-icon-check" round style="width: 100%;" type="primary" class="btn-box-shadow">Confirmar remoção de proprietário</el-button> 
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item v-if="form.tipoEntidade === 'PROPRIETARIO' && isAdicionarNovoProprietario === false && isSelecionarNovoProprietario === false">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-button @click="adicionarNovoProprietarioHandler" round type="success" style="width: 100%;">Adicionar Proprietário</el-button>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item v-if="form.tipoEntidade === 'PROPRIETARIO' && isAdicionarNovoProprietario === true">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-button @click="confirmarAdicaoNovoProprietario()" round type="success" style="width: 100%;">Confirmar</el-button>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item v-if="form.tipoEntidade === 'PROPRIETARIO' && isAdicionarNovoProprietario === true">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-button @click="cancelarAdicionarNovoProprietarioHandler" round type="danger" style="width: 100%;">Cancelar</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-form :model="form" size="small" label-position="top" hide-required-asterisk v-if="estagioAtual === 1">
      <el-form-item label="Upload Arquivo Aditivo:">
        <el-upload :file-list="listFiles" :on-change="handleChangeUpload" :on-remove="limparListaArquivos" name="arquivo" :action="''" :multiple="false" :limit="1" :auto-upload="false" class="file-upload-box">
          <el-button type="primary" slot="trigger" style="width: 100%" icon="el-icon-search" round class="btn-box-shadow">Selecionar Arquivo</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item label=" " v-if="hasFileSelected">
        <el-button @click="uploadArquivo" round class="btn-box-shadow" type="success" style="width: 100%;" icon="el-icon-upload">Confirmar Upload</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    visibility: Boolean,
    proprietarios: Array,
    locatario: Object,
    aluguel: Object,
    imovel: Object
  },

  data() {
    return {
      form: {
        tipoEntidade: 'PROPRIETARIO'
      },

      listFiles: [],

      clientePesquisado: undefined,
      proprietarioNovo: undefined,

      tiposEntidade: [
        { label: 'Proprietário', data: 'PROPRIETARIO' },
        { label: 'Locatário', data: 'LOCATARIO' }
      ],

      loadingCliente: false,

      isSelecionarNovoLocatario: false,

      isAdicionarNovoProprietario: false,

      isSelecionarNovoProprietario: false,

      listaProprietarios: JSON.parse(JSON.stringify(this.proprietarios)),

      listaProprietariosAnterior: undefined,

      estagioAtual: 0,

      proprietarioASerRemovido: {},
      
      arquivo: {
        localizacaoFisica: ""
      },

      adicionandoNovoProprietario: false
    }
  },

  watch: {
    proprietarios: {
      handler(novo) {
        if(!novo || !novo.length) return

        this.listaProprietarios = JSON.parse(JSON.stringify(novo))
      }
    }
  },

  computed: {
    ...mapState('alugueisRelatoriosStore', {
      clientesDisponiveis(state) { return state.clientesDisponiveis },
    }),

    clientesDisponiveisFiltrado() {
      return this.clientesDisponiveis.filter((cliente) => {
        if(this.proprietarioSelecionadoParaTroca) {
          return cliente.id !== this.proprietarioSelecionadoParaTroca.id
        } else {
          return cliente.id
        }
      })
      .filter((cliente) => {
        return cliente.id !== this.locatario.id
      }).filter((cliente) => {
        let finded = false;
        for(let i = 0; i < this.listaProprietarios.length; i++) {
          if(cliente.id === this.listaProprietarios[i].id) {
            finded = true;
          }
        }

        return !finded;
      });
    },

    proprietarioSelecionadoParaTroca() {
      return this.listaProprietarios.filter((proprietario) => proprietario.isSelecionadoParaTroca)[0];
    },

    isEntidadeProprietario() {
      return this.form.tipoEntidade === 'PROPRIETARIO'
    },

    isEntidadeLocatario() {
      return this.form.tipoEntidade === 'LOCATARIO'
    },

    isExibirNovoCliente() {
      return this.proprietarioSelecionadoParaTroca || this.isSelecionarNovoLocatario
    },

    loading() {
      return this.$store.state.loading;
    },

    hasFileSelected() {
      return this.listFiles.length > 0
    },

    totalParticipacaoProprietariosRestantes() {
      return this.listaProprietarios.filter(item => item.id !== this.proprietarioASerRemovido.id).reduce((soma, proprietario) => soma + proprietario.perfis[0].participacaoImovel, 0);
    },

    isListaProprietariosSomenteUm() {
      return this.listaProprietarios.length === 1;
    }
  },

  methods: {
    ...mapActions(['showLoading', 'hideLoading']),
    ...mapActions("alugueisRelatoriosStore", ["listarClientes"]),
    ...mapActions("alugueisContratosStore", [
      "trocarTitularidadeProprietario", 
      "uploadArquivoAluguel", 
      "trocarTitularidadeLocatario",
      "removerProprietarioAluguel",
      "adicionarProprietarioContrato"
    ]),

    trocarLocatario() {
      this.isSelecionarNovoLocatario = true;
    },

    adicionarNovoProprietarioHandler() {
      this.isAdicionarNovoProprietario = true;
      this.listaProprietariosAnterior = this.listaProprietarios;
    },

    cancelarAdicionarNovoProprietarioHandler() {
      this.isAdicionarNovoProprietario = false;
      this.listaProprietarios = this.listaProprietariosAnterior;
      this.proprietarios = this.listaProprietarios;
      this.listaProprietariosAnterior = undefined;
      this.adicionandoNovoProprietario = false;
    },

    verificarProprietarioComTrocaAtiva(proprietarioLista) {
      return this.proprietarioSelecionadoParaTroca && (proprietarioLista.id == this.proprietarioSelecionadoParaTroca.id);
    },

    selecionarProprietarioParaTroca(index) {
      this.isSelecionarNovoProprietario = true;
      let proprietarioSelecionado = this.listaProprietarios[index];
      proprietarioSelecionado.isSelecionadoParaTroca = true;

      this.listaProprietarios[index] = proprietarioSelecionado;
    },

    desselecionarProprietarioParaTroca(index) {
      this.isSelecionarNovoProprietario = false;
      let proprietarioSelecionado = this.listaProprietarios[index]
      proprietarioSelecionado.isSelecionadoParaTroca = false;

      this.listaProprietarios[index] = proprietarioSelecionado;
    },

    confirmarNovoClienteHandler() {
      if(this.isAdicionarNovoProprietario) {
        this.adicionarProprietarioHandler();
      } else {
        switch (this.form.tipoEntidade) {
        case 'PROPRIETARIO':
          this.alterarProprietarioHandler();
          break;
        case 'LOCATARIO':
          this.alterarLocatarioHandler();
          break;
        }
      }
    },

    confirmarAdicaoNovoProprietario() {
      if(this.totalParticipacaoProprietariosRestantes < 100 || this.totalParticipacaoProprietariosRestantes > 100) {
        this.$message.warning('A soma da participação no imóvel entre os proprietários deve ser 100!');
        
        return;
      }

      this.showLoading();

      const payload = this.montarPayloadAdicionarProprietario(this.proprietarioNovo);

      this.adicionarProprietarioContrato(payload)
      .then(resposta => {
        switch (resposta.status) {
          case 'SUCESSO':
            this.$message.success(resposta.mensagem);
            this.estagioAtual = 1;
            break;
          case "FALHA":
            this.$message.warning(resposta.mensagem);
            break;
          default: 
            this.$message.error(resposta.mensagem);
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
      }).finally(() => {
        this.hideLoading();
        this.adicionandoNovoProprietario = false
      })
    },
    
    adicionarProprietarioHandler() {
      if(!this.clientePesquisado) {
        return
      }

      const novoProprietario = {
        ...this.clientePesquisado,
        perfis: [{ participacaoImovel: 0,
        participacaoRecebimento: 100,
        cliente: this.clientePesquisado }]
      }

      this.proprietarioNovo = novoProprietario;

      this.proprietarios = [...this.proprietarios, novoProprietario];

      this.clientePesquisado = undefined;

      this.adicionandoNovoProprietario = true;
    },

    alterarProprietarioHandler() {
      if(!this.clientePesquisado) {
        return
      }

      this.$confirm("Ao alterar a titularidade, todos os repasses em aberto serão transferidos ao novo proprietário. Deseja realmente continuar?", {
        confirmButton: 'Confirmar',
        cancelButton: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.alterarProprietario();
      })
    },

    alterarLocatarioHandler() {
      if(!this.clientePesquisado) {
        return;
      }

      this.$confirm("Ao alterar a titularidade, todos os recibos em aberto e não registrados serão transferidos ao novo proprietário. Deseja realmente continuar?", {
        confirmButton: 'Confirmar',
        cancelButton: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.alterarLocatario();
      })
    },

    alterarProprietario() {
      const payload = this.montarPayloadProprietario();

      this.showLoading();

      this.trocarTitularidadeProprietario(payload)
      .then(resposta => {
        switch (resposta.status) {
          case 'SUCESSO':
            this.$message.success(resposta.mensagem);

            this.estagioAtual = 1;
            break;
          case 'FALHA':
            this.$message.warning(resposta.mensagem);
            break;
          default: 
            this.$message.error(resposta.mensagem);
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
      }) .finally(() => {
        this.hideLoading();
      })
    },

    alterarLocatario() {
      const payload = this.montarPayloadLocatario();

      this.showLoading();

      this.trocarTitularidadeLocatario(payload)
      .then(resposta => {
        switch (resposta.status) {
          case 'SUCESSO':
            this.$message.success(resposta.mensagem);

            this.estagioAtual = 1;

            break;
          case 'FALHA':
            this.$message.warning(resposta.mensagem);
            break;
          default:
            this.$message.error(resposta.mensagem);
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
      }).finally(() => {
        this.hideLoading();
      })
    },

    montarPayloadProprietario() {
      return {
        tipoEntidade: 'PROPRIETARIO',
        aluguel: this.aluguel,
        imovel: this.imovel,
        clienteAnterior: {...this.proprietarioSelecionadoParaTroca, isSelecionadoParaTroca: undefined},
        clienteNovo: this.clientePesquisado,
        naoTransferirRecibosAtrasados: this.form.naoTransferirRecibosAtrasados
      }
    },

    montarPayloadLocatario() {
      return {
        tipoEntidade: 'LOCATARIO',
        aluguel: this.aluguel,
        imovel: this.imovel,
        clienteAnterior: this.locatario,
        clienteNovo: this.clientePesquisado,
        naoTransferirRecibosAtrasados: this.form.naoTransferirRecibosAtrasados
      }
    },

    selecionarProprietarioASerRemovidoHandler(proprietarioRemovido) {
      this.proprietarioASerRemovido = proprietarioRemovido;
    },

    cancelarRemocaoDeProprietario() {
      this.proprietarioASerRemovido = {}
    },

    confirmarRemocaoProprietarioHandler(proprietarioRemovido) {
      if(this.totalParticipacaoProprietariosRestantes < 100) {
        this.$message.warning('O valor da soma das participações deve ser igual a 100');
        return;
      }

      const payload = this.montarPayloadRemoverProprietario(proprietarioRemovido);

      this.showLoading();

      this.limparForm()

      this.removerProprietarioAluguel(payload)
      .then(resposta => {
        switch (resposta.status) {
          case "SUCESSO":
            this.$message.success(resposta.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resposta.mensagem);
            break;
          case "ERRO":
            this.$message.error(resposta.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error("Erro ao comunicar-se com o servidor.")    
      }).finally(() => {
        this.fechar();
        this.hideLoading();
      })
    },

    montarPayloadRemoverProprietario(proprietarioRemovido) {
      return {
        aluguel: this.aluguel,
        imovel: this.imovel,
        clienteAnterior: { ...proprietarioRemovido, isSelecionadoParaTroca: undefined },
        proprietarios: this.listaProprietarios.filter(item => item.id !== this.proprietarioASerRemovido.id).map(item => {
          return { ...item, isSelecionadoParaTroca: undefined }
        })
      }
    },

    montarPayloadAdicionarProprietario(proprietarioAdicionado) {
      return {
        aluguel: this.aluguel,
        imovel: this.imovel,
        clienteNovo: { ...proprietarioAdicionado, isSelecionadoParaTroca: undefined },
        proprietarios: this.listaProprietarios.map(item => {
          return { ...item, isSelecionadoParaTroca: undefined }
        })
      }
    },

    uploadArquivo() {
      let payload = new FormData();

      payload.append("arquivo", this.listFiles[0].raw);
      payload.append("descricao", "Aditivo troca de Titularidade.");
      payload.append("localizacaoFisica", this.arquivo.localizacaoFisica);
      payload.append("path", this.listFiles[0].name);

      payload.append("idAluguel", this.aluguel.id); 

      this.showLoading()
      this.uploadArquivoAluguel(payload)
      .then(resultado => {
        this.hideLoading();

        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      }).finally(() => {
        this.fechar();
      });
    },

    handleChangeUpload(file, fileList) {
      this.listFiles = fileList;
    },

    limparListaArquivos() {
      this.listFiles = []
    },

    filtrarClientesSelect(queryString) {
      let payload = { };

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingCliente = true;
      this.listarClientes(payload)
        .then(() => {
          this.loadingCliente = false;
        })
        .catch(() => {
          this.loadingCliente = false;
        });
    },
    
    fechar() {
      this.$emit('close');
      this.limparForm();
    },

    limparForm() {
      this.form = {
        tipoEntidade: 'PROPRIETARIO',
      }

      this.listFiles = []

      this.estagioAtual = 0;

      this.limparChangeEntidade();

      this.proprietarioASerRemovido = {}

      this.isAdicionarNovoProprietario = false;
    },

    limparChangeEntidade() {
      this.isSelecionarNovoLocatario = false;

      this.listaProprietarios = JSON.parse(JSON.stringify(this.proprietarios));
    },

    maxPara(index) {
      const somaOutros = this.proprietarioASerRemovido.id ? this.totalParticipacaoProprietariosRestantes - this.listaProprietarios.filter(item => item.id !== this.proprietarioASerRemovido.id)[index].perfis[0].participacaoImovel : 0;

      return 100 - somaOutros;
    }
  }
}
</script>

<style>
.tabela-detalhes-clientes {
  border-collapse: separate ;
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 25px;
  box-shadow: 
    inset 0 1px 0 #ffffff,
    0 0 8px rgba(0, 0, 0, 0.1);
}

.tabela-detalhes-clientes td {
  border: none;
  border-bottom: 1px solid #b8b3b3;
  padding: 8px 10px;
}

.tabela-detalhes-clientes th {
  border: none;
  border-bottom: 1px solid #b8b3b3;
  padding: 8px 10px;
}

.tabela-detalhes-clientes tr:last-child td{
  border-bottom: none;
}

.no-increase .el-input-number__increase {
  pointer-events: none;
  opacity: 0.4;
}
</style>